const initialState = () => {
  return {
    isAuthenticated: false,
    current: {
      user: {
        name: "",
        status: false,
        token: "",
        uhash: "",
        utype: "",
        recipes_access: 0,
        invoices_access: 0,
        vendors_access: 0,
        stocks_access: 0,
      },
    },
  };
};

const storeUser = {
  namespace: true,
  state: initialState(),
  mutations: {
    LOGIN(state, payload) {
      Object.assign(state.current.user, payload);
      state.isAuthenticated = true;
    },
    LOGOUT(state) {
      state.isAuthenticated = false;
      var reset = initialState();
      Object.assign(state.current.user, reset.current.user);
    },
  },
  actions: {
    logoutService({ commit, dispatch }) {
      commit("RESET_RBAC_ME");
      commit("RESET_RBAC_LISTS");
      commit("RESET_APPROVALS");
      commit("RESET_LIVEORDERS");
      commit("RESET_GROUPORDERS");
      commit("RESET_CREATIONS");
      commit("RESET_FEATURED");
      dispatch("chatStop");
      dispatch("assistantReset");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("uhash");
      localStorage.removeItem("utype");
      localStorage.removeItem("expDate");
      localStorage.removeItem("recipes_access");
      localStorage.removeItem("invoices_access");
      localStorage.removeItem("vendors_access");
      localStorage.removeItem("stocks_access");
      commit("LOGOUT");
      return Promise.resolve();
    },
  },
  getters: {
    getUser: (state) => {
      return state.current.user;
    },
  },
};

export default storeUser;
